"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
exports.Divider = styled_components_1.default.div `
  height: ${(props) => (props === null || props === void 0 ? void 0 : props.height) || '1px'};
  background-color: ${(props) => ((props === null || props === void 0 ? void 0 : props.backgroundColor) ? props.backgroundColor : monera_app_core_1.rioBoxColors.divider)};
  margin: ${(props) => props === null || props === void 0 ? void 0 : props.margin};
  width: ${(props) => (props === null || props === void 0 ? void 0 : props.width) || '100%'};
`;
